import React from 'react';
import SemanticHeader from '../Chapter/semantic-header';
import ImageBlock from '../ImageBlock';
import { RadioButton } from './RadioButton';

const QuizQuestion = ({
  questionText,
  answerAlternatives,
  image,
  onAnswer,
  blockId,
  selectedAnswer,
  quizInProgress,
  correctFeedbackText,
  incorrectFeedbackText,
  correctAnswerLink,
  correctAnswerLinkText,
  friendlyCorrectLinkName,
  incorrectAnswerLink,
  incorrectAnswerLinkText,
  friendlyIncorrectLinkName,
  currentAnswerIndex,
  chapterContainerHasHeading,
}) => {
  const correctLinkText = correctAnswerLinkText || friendlyCorrectLinkName;

  const incorrectLinkText =
    incorrectAnswerLinkText || friendlyIncorrectLinkName;

  const link = selectedAnswer?.IsCorrect
    ? correctAnswerLink
    : incorrectAnswerLink;

  const linkText = selectedAnswer?.IsCorrect
    ? correctLinkText
    : incorrectLinkText;

  const answerQuestion = (answer) => {
    onAnswer(answer);
  };

  return (
    <div className={'c-quiz-question'}>
      <SemanticHeader
        isH3={!chapterContainerHasHeading}
        isH4={chapterContainerHasHeading}
        className="c-quiz-container__heading"
      >
        {`${
          currentAnswerIndex && !quizInProgress ? currentAnswerIndex + '.' : ''
        } ${questionText}`}
      </SemanticHeader>
      <div>{image && <ImageBlock {...image}></ImageBlock>}</div>
      <ul>
        {answerAlternatives?.map((answer, i) => (
          <RadioButton
            key={i}
            text={answer.AnswerText}
            name={`question-${blockId}`}
            checked={selectedAnswer?.AnswerText === answer.AnswerText}
            onChange={() => answerQuestion(answer)}
            isValid={
              selectedAnswer?.AnswerText === answer.AnswerText &&
              selectedAnswer?.IsCorrect
            }
            isValidated={!quizInProgress}
          />
        ))}
      </ul>
      {selectedAnswer && !quizInProgress && (
        <div className="c-quiz-question__feedback">
          <div
            dangerouslySetInnerHTML={{
              __html: selectedAnswer?.IsCorrect
                ? correctFeedbackText
                : incorrectFeedbackText,
            }}
          />
          {link && linkText && (
            <a className="c-quiz-question__feedback__link" href={link}>
              {linkText}
            </a>
          )}
        </div>
      )}
    </div>
  );
};

export default QuizQuestion;
